export const ENCODED_SLASH = encodeURIComponent('/');

export const XMATTERS_URL = 'http://www.xmatters.com';
export const XMATTERS_SIGN_ON_URL = '/xmatters/signOn.do';
const SIGN_OUT_URL_PARAMS = window.ebfd
  ? `eb_user_role_id=${encodeURIComponent(
      window.ebfd.ebUserRoleId,
    )}&cas_token_api_name=${encodeURIComponent(window.ebfd.tokenApiName)}`
  : '';
export const XMATTERS_SIGN_OUT_URL = `/xmatters/signOut.do${
  SIGN_OUT_URL_PARAMS.length > 0 ? `?${SIGN_OUT_URL_PARAMS}` : ''
}`;
export const PRIVACY_POLICY_URL = `${XMATTERS_URL}/policy/privacy-policy`;

export const DEFAULT_FONT_CSS_URL =
  '//cloud.typography.com/7418272/676606/css/fonts.css';
export const XMATTERS_CONTACT_SALES_URL = `${XMATTERS_URL}/company/contact-us/?sales`;
export const XMATTERS_SIGN_ON_RELOGIN_URL = `${XMATTERS_SIGN_ON_URL}?relogin=true`;
export const XMATTERS_SIGN_OUT_URL_AUTO_TIMEOUT = `/xmatters/signOut.do?autoTimeout=true&${SIGN_OUT_URL_PARAMS}`;

// Internal app paths:
export const DYNAMIC_TEAMS_LIST_BASE_URL = 'DynamicTeams';
export const DYNAMIC_TEAMS_DETAILS_URL_BASE_URL = 'dynamic-teams';
export const GROUP_LIST_URL = 'groups';
export const PLAN_OVERVIEW_URL = 'PlanOverviewPlace:none';
export const SWIPE_TO_BUY_URL = 'PlanUpgradePlace/choosePlan';
export const USER_LIST_URL = 'users';
export const USER_PROFILE_URL_BASE_URL = 'users';

// Help links for products:
export const EBFD_HELP_URL_ROOT = 'https://help.everbridge.net';
export const EBFD_HELP_URL = `${EBFD_HELP_URL_ROOT}/flowdesigner`;
export const XMATTERS_HELP_URL_ROOT = 'https://help.xmatters.com';
export const XMATTERS_HELP_URL = `${XMATTERS_HELP_URL_ROOT}/ondemand`;
